import axios from 'axios';
export async function updatePlanCadastro(plano, cnpj) {
    const url = process.env.VUE_APP_APIURL
    const data = {
        plan: plano.planoId,
        value: plano.preco
    };
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': cnpj
        }
    };
    const atualizaCadastro = await axios.post(`${url}/public/updatePlanCadastro`, data, config);
    return atualizaCadastro
}